// API Response Types

export enum SpendingType {
  ESSENTIAL = "essential",
  DISCRETIONARY = "discretionary",
  UNCATEGORIZED = "uncategorized"
}

export interface BudgetPlanResponse {
  id: number;
  user_id: string;
  headers: BudgetHeader[];
  is_active: boolean;
  custom_config?: any;
  created_at: string;
  updated_at: string;
  monthly_total: number;
  yearly_total: number;
  total_spent: number;
  total_allocated: number;
  total_remaining: number;
  total_percentage_used: number;
  due_this_month: number;
  date_range?: { start_date: string; end_date: string };
  name?: string;
}

export interface BudgetHeader {
  id: number;
  name: string;
  description?: string;
  monthly_total: number;
  yearly_total: number;
  categories: BudgetCategory[];
  spending_type: SpendingType;
}

export interface BudgetCategory {
  id: number;
  name: string;
  allocated: number;
  spent: number;
  remaining: number;
  percentage_used: number;
  frequency_type: "week" | "month";
  frequency_value: number;
  monthly_amount: number;
  yearly_amount: number;
  is_due_this_month: boolean;
  frequency: string;
  header_name: string;
  header_id: number;
  iso_currency_code: string;
}

export interface BudgetSummary {
  id: number;
  user_id: string;
  custom_config?: any;
  is_active: boolean;
  created_at: string;
  updated_at: string;
  headers: BudgetHeader[];
  monthly_total: number;
  yearly_total: number;
  total_spent: number;
  total_allocated: number;
  total_remaining: number;
  total_percentage_used: number;
  due_this_month: number;
  date_range?: { start_date: string; end_date: string };
  name: string;
  is_shared: boolean;
  is_owner: boolean;
  shared_role?: 'owner' | 'member';
  shared_status?: 'pending' | 'active' | 'declined';
}

// Frontend Types (simplified versions for display/selection)
export interface SimpleCategoryHeader {
  id: string;
  name: string;
  categories: SimpleCategory[];
  spending_type: SpendingType;
}

export interface SimpleCategory {
  id: string;
  name: string;
  header_id: string;
}

// Type conversion helpers
export const convertToSimpleHeader = (header: BudgetHeader): SimpleCategoryHeader => ({
  id: header.id.toString(),
  name: header.name,
  categories: header.categories.map(cat => ({
    id: cat.id.toString(),
    name: cat.name,
    header_id: header.id.toString()
  })),
  spending_type: header.spending_type,
});

export interface SharedMember {
  user_id: string;
  role: string;
  status: string;
  email: string;
  first_name?: string;
  last_name?: string;
  created_at: string;
}

export interface BudgetPlan {
  id: number;
  user_id: string;
  is_active: boolean;
  created_at: string;
  updated_at: string;
  custom_config?: any;
} 